import { MAP_LAYER_MONITOR_SOURCE } from "@/v2-backoffice-client/layer/layer.constants"
import { useUptimeInlineByKeyQuery } from "@/v2-backoffice-client/uptime/inline/byKey/uptime.inline.byKey.query"
import { getUptimeSheetHref } from "@/v2-backoffice-client/uptime/uptime.utils"

type UseLayerUptimeTargetInput = {
  featureCode: string
  // True while the sheet's on-open live probe is in flight; keeps the values
  // loading instead of flashing "no monitor" for a layer whose first-ever
  // probe is running right now.
  isProbing?: boolean
}

/**
 * The layer's uptime target for the sheet's inline items: the (source,
 * identifier: FeatureCode) plumbing and the link to its uptime sheet,
 * pushed on top of the layer sheet so the breadcrumb leads back. Both
 * items call this; Apollo serves the second from the first's request.
 */
export function useLayerUptimeTarget(input: UseLayerUptimeTargetInput) {
  const { featureCode, isProbing } = input

  const { data, loading } = useUptimeInlineByKeyQuery({
    variables: {
      input: { source: MAP_LAYER_MONITOR_SOURCE, identifier: featureCode },
    },
  })

  return {
    target: data?.getUptimeTarget,
    isLoading: loading || Boolean(isProbing),
    detailHref: getUptimeSheetHref(MAP_LAYER_MONITOR_SOURCE, featureCode, {
      push: true,
    }),
  }
}
